module.exports = __webpack_public_path__ + "static/logo-512-inverse-no-border.fa107416.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/logo-512-inverse-no-border.png
// module id = 337
// module chunks = 35783957827783